import React, { useEffect, useMemo, useState } from "react";
import { useSchedulingClient } from "./scheduling.client";
import { SchedulingConfig } from "./SchedulingConfig.page";
export const SchedulingConnect = () => {
    const { getInstallUrl, getIntegration, disconnectIntegration, getGrant } = useSchedulingClient();
    const [loading, setLoading] = useState(true);
    const [integration, setIntegration] = useState();
    const [isGrantInvalid, setIsGrantInvalid] = useState(false);
    const loadIntegrations = async () => {
        try {
            setLoading(true);
            const list = await getIntegration();
            setIntegration(list);
            if (list) {
                const grant = await getGrant();
                if (grant.data?.grant_status === 'invalid') {
                    setIsGrantInvalid(true);
                }
            }
        }
        catch (e) {
            // @TODO: FLU-193 Handle this.
            console.error('Failed to load scheduling integrations', e);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadIntegrations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const isIntegrationValid = useMemo(() => {
        return !loading && integration && !isGrantInvalid;
    }, [integration, isGrantInvalid, loading]);
    return (React.createElement("div", { className: "space-y-6" },
        React.createElement("div", { className: "border border-gray-200 rounded-xl p-4 bg-white shadow-sm" },
            React.createElement("div", { className: "flex items-center justify-between mb-3" },
                React.createElement("div", null,
                    React.createElement("div", { className: "text-gray-800 font-medium" }, "Scheduling"),
                    React.createElement("div", { className: "text-gray-500 text-sm" }, "Manage your Nylas scheduling connection")),
                React.createElement("button", { className: "px-3 py-2 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors", onClick: loadIntegrations }, "Refresh")),
            loading ? (React.createElement("div", { className: "text-sm text-gray-500" }, "Loading...")) : (isIntegrationValid) ? (React.createElement("div", { className: "space-y-3" },
                React.createElement("div", { className: "flex items-center justify-between p-3 border border-gray-200 rounded-lg" },
                    React.createElement("div", { className: "text-gray-800 font-medium" }, integration.accountName || integration.grantId || 'Nylas Account'),
                    React.createElement("button", { className: "px-3 py-1.5 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 transition-colors text-sm", onClick: async () => {
                            try {
                                if (!confirm('Disconnect scheduling integration?'))
                                    return;
                                await disconnectIntegration();
                                await loadIntegrations();
                            }
                            catch (e) {
                                // @TODO: FLU-193 Handle this.
                                console.error('Failed to disconnect scheduling integration', e);
                            }
                        } }, "Disconnect")))) : (React.createElement("div", { className: "flex items-center justify-between" },
                React.createElement("div", { className: "text-gray-500 text-sm" }, isGrantInvalid ? 'Please reauthenticate.' : 'No scheduling connection found for this organization.'),
                React.createElement("button", { className: "px-4 py-2 rounded-lg bg-gradient-to-r from-orange-500 to-orange-600 text-white hover:from-orange-600 hover:to-orange-700 transition-colors", onClick: async () => {
                        try {
                            const data = await getInstallUrl();
                            if (data.installUrl) {
                                window.location.href = data.installUrl;
                            }
                        }
                        catch (e) {
                            // @TODO: FLU-193 Handle this.
                            console.error('Failed to start scheduling OAuth', e);
                        }
                    } }, "Connect")))),
        isIntegrationValid && React.createElement(SchedulingConfig, { integration: integration })));
};
export default SchedulingConnect;
